var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 121,
    viewBox: "0 0 123 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2284_160276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6012 121C27.9423 121.108 0.546754 94.0452 0.437825 60.7162C0.328896 27.3331 27.6155 0.0540989 61.1655 8.10472e-05C94.9878 -0.0539368 122.383 26.901 122.438 60.4461C122.547 93.7751 95.2601 120.892 61.6012 121ZM61.6012 8.64294C32.6807 8.64294 9.20658 31.7626 9.15211 60.338C9.09765 88.9675 32.5173 112.303 61.2744 112.357C90.3039 112.357 113.724 89.1836 113.724 60.3921C113.724 31.9787 90.2494 8.69696 61.6012 8.64294Z",
    fill: "#AFB8CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0804 56.1794C57.0804 49.1031 57.0804 42.4589 57.0804 35.8147C57.0804 32.2495 58.7687 30.1968 61.5464 30.3048C64.2696 30.3589 65.7946 32.3575 65.7946 35.8147C65.7946 42.5129 65.7946 49.2651 65.7946 56.2334C72.2759 56.2334 78.5393 56.2334 84.8027 56.2334C85.7286 56.2334 86.6 56.1794 87.5259 56.2334C90.0857 56.3955 91.883 58.124 91.9375 60.4468C91.992 62.8776 90.1402 64.8223 87.417 64.8223C81.4259 64.8763 75.4348 64.8223 69.4437 64.8763C68.3545 64.8763 67.2652 64.8763 65.7946 64.8763C65.7946 66.1187 65.7946 67.2531 65.7946 68.3874C65.7946 74.2214 65.8491 80.1093 65.7946 85.9432C65.7946 88.9142 63.9973 90.8048 61.4375 90.8048C58.8777 90.8048 57.0804 88.9142 57.0804 85.9972C57.0259 79.083 57.0804 72.1687 57.0804 64.8763C52.5054 64.8763 48.0938 64.8763 43.6821 64.8763C41.0679 64.8763 38.3991 64.9303 35.7848 64.8763C32.8438 64.8223 30.9375 63.0397 30.9375 60.5008C30.992 57.962 32.8438 56.2874 35.8393 56.2334C42.2116 56.1794 48.5295 56.2334 54.9018 56.2334C55.5554 56.1794 56.1545 56.1794 57.0804 56.1794Z",
    fill: "#AFB8CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2284_160276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 121,
    fill: "white",
    transform: "translate(0.4375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.d4d1b264cfe48b09988f6d521790b57f.svg";
export { ForwardRef as ReactComponent };